import { CannedMessage } from 'services/types';

export type IStatusChat = 'all' | 'open' | 'closed' | 'onhold';
export enum STATUS_UPLOAD {
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
}

export enum SESSION_TYPE {
  IN_ATTENDANCE = 'inAttendance',
  PENDING = 'pending',
  CLOSED_TODAY = 'closedToday',
  STARTED_BY_YOU = 'startedByYou',
  ON_HOLD = 'onHold',
}

export interface FileQueue {
  name: string;
  status?: STATUS_UPLOAD;
  progress?: number;
}

export type IChatStore = {
  selectedCannedMessages: Record<string, CannedMessage | null>;
  roomTagNames: string[];
  fileQueue: FileQueue[];
};
